import React, { memo, useEffect, useRef, useState } from 'react';
import bem from 'utils/bem';
import './index.sass';
import { useSwipe } from './useSwipe';
import { usePreventVerticalScroll } from 'components/Slider/MobileSlider/usePreventVerticalScroll';

const { block, el } = bem('mobile-slider');

const MobileSlider = memo(({ items }) => {
    const preventScrollRef = useRef(null);
    const [ current, setCurrent ] = useState(0);

    useEffect(() => {
        console.log('reset');
        setCurrent(0)
    }, [items])

    usePreventVerticalScroll(preventScrollRef);

    const onSwipeLeft = () => {
        setCurrent(oldCurrent => {
            return Math.min(++oldCurrent, items.length - 1)
        })
    }
    const onSwipeRight = () => {
        setCurrent(oldCurrent => {
            return Math.max(--oldCurrent, 0)
        })
    }

    const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe({onSwipeLeft, onSwipeRight})

    return (
        <div className={el('prevent-scroll-wrapper')} ref={preventScrollRef}>
            <div className={block()} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
                <div className={el('window')}>
                    <div className={el('tape')} style={{transform: `translateX(calc(${ current } * (-85% - 16px)))`}}>
                        {items.map((item, index) => <div key={index} className={el('slide', { 'current': current === index })}>{item}</div>)}
                    </div>
                </div>
            </div>
        </div>
    )
})

export default MobileSlider;
